import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useStateContext } from '../contexts/ContextProvider';
import { Notification } from '../components';

const GuestLayout = () => {
  const { token } = useStateContext();
  if (token) {
    return <Navigate to="/" />
  }
  return (
    <div translate='no' className='h-screen bg-gray-100 animated fadeInDown'>
      
      <Outlet />
    </div>
  )
}

export default GuestLayout